module.exports = __webpack_public_path__ + "static/img/IMG_20170525_104254.f8ad540a.jpg";